import { EcommerceAPIApi as EcommerceApi, Vehicle } from '@parkingbase/ecommerce-api-demo';
import { BaseApiService } from './baseApi.service';

export class VehicleService extends BaseApiService {
  protected userApi: EcommerceApi;

  constructor() {
    super();
    this.userApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  private withDefaultName(vehicle: Vehicle): Vehicle {
    const { vehicleMake, vehicleModel, vehicleName } = vehicle.vehicleInfo;
    if (!vehicleName) {
      return {
        ...vehicle,
        vehicleInfo: {
          ...vehicle.vehicleInfo,
          vehicleName: `${vehicleMake} ${vehicleModel}`.trim(),
        },
      };
    }
    return vehicle;
  }

  async getUserVehicles() {
    const response = await this.userApi.getUserVehicles();
    return response.data;
  }

  async createVehicle(vehicle: Vehicle) {
    const response = await this.userApi.createVehicle(this.withDefaultName(vehicle));
    return response.data;
  }

  async updateVehicle(vehicle: Vehicle) {
    const response = await this.userApi.updateVehicle(
      vehicle.documentId as string,
      this.withDefaultName(vehicle)
    );
    return response.data;
  }

  async deleteVehicle(id: string) {
    const response = await this.userApi.deleteVehicle(id);
    return response.data;
  }

  async vinLookup(vin: string) {
    const response = await fetch(
      `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${encodeURIComponent(vin)}?format=json`
    );
    const data = await response.json();
    return data?.Results?.[0] ?? null;
  }
}
